/* eslint-disable import/no-anonymous-default-export */
import Home from "../routes/home";
import Companies from "../routes/insurance-companies";
import InsuranceRequests from "../routes/insurance-requests";
import Agencies from "../routes/agencies";
import AgencyLists from "../routes/agency-lists";
import Roles from "../routes/roles";
import Users from "../routes/users";
import BalanceRequests from "../routes/balance-requests";
import FinancialRequests from "../routes/financial-requests";
import Reports from "../routes/reports";
import Translations from "../routes/translations";
import Expenses from "../routes/expenses";
import Leads from "../routes/leads";
import Announcements from "../routes/announcements";
import Profits from "../routes/profits";
import DeveloperTools from "../routes/developer-tools";
import Options from "../routes/options";
import Messaging from "../routes/messaging";
import DebtRequests from "../routes/debt-requests";
import MessageRequests from "../routes/message-requests";
import ResidenceAppointments from "../routes/residence-appointments";
import BulkRatiosRequests from "../routes/bulk-ratios-requests";
import DebtSendingComponent from "../routes/debtsending-schedules";
import InvoicesComponent from "../routes/invoices";
import SupplierBillsComponent from "../routes/supplier-bills";
import PaymentsComponent from "../routes/payments";
import PaymentMethodsComponent from "../routes/payment-methods";
import CustomersComponent from "../routes/customers";
import ServicesComponent from "../routes/services";
import ServiceNamesComponent from "../routes/service-names";
import SourcesComponent from "../routes/sources";
import InvoicesDashboardComponent from "../routes/invoices-dashboard";
import MoneyAccountsComponent from "../routes/money-accounts";
import SmsMessagesComponent from "../routes/sms-messages";
import WhatsappDevices from "../routes/whatsapp-devices";

export default [
  {
    path: "home",
    component: Home,
  },
  {
    path: "insurance-companies",
    component: Companies,
  },
  {
    path: "expenses",
    component: Expenses,
  },
  {
    path: "insurance-requests",
    component: InsuranceRequests,
  },
  {
    path: "balance-requests",
    component: BalanceRequests,
  },
  {
    path: "profits",
    component: Profits,
  },
  {
    path: "financial-requests",
    component: FinancialRequests,
  },
  {
    path: "agencies",
    component: Agencies,
  },
  {
    path: "agency-lists",
    component: AgencyLists,
  },
  {
    path: "leads",
    component: Leads,
  },
  {
    path: "roles",
    component: Roles,
  },
  {
    path: "reports",
    component: Reports,
  },

  {
    path: "users",
    component: Users,
  },
  {
    path: "announcements",
    component: Announcements,
  },
  {
    path: "translations",
    component: Translations,
  },
  {
    path: "developer-tools",
    component: DeveloperTools,
  },
  {
    path: "options",
    component: Options,
  },
  {
    path: "messaging",
    component: Messaging,
  },
  {
    path: "debt-requests",
    component: DebtRequests,
  },
  {
    path: "message-requests",
    component: MessageRequests,
  },
  {
    path: "residence-appointments",
    component: ResidenceAppointments,
  },
  {
    path: "bulk-ratios-requests",
    component: BulkRatiosRequests,
  },
  {
    path: "debtsending-schedules",
    component: DebtSendingComponent,
  },
  {
    path: "invoices",
    component: InvoicesComponent,
  },
  {
    path: "supplier-bills",
    component: SupplierBillsComponent,
  },
  {
    path: "payments",
    component: PaymentsComponent,
  },
  {
    path: "payment-methods",
    component: PaymentMethodsComponent,
  },
  {
    path: "customers",
    component: CustomersComponent,
  },
  {
    path: "services",
    component: ServicesComponent,
  },
  {
    path: "service-names",
    component: ServiceNamesComponent,
  },
  {
    path: "sources",
    component: SourcesComponent,
  },
  {
    path: "invoices-dashboard",
    component: InvoicesDashboardComponent,
  },
  {
    path: "money-accounts",
    component: MoneyAccountsComponent,
  },
  {
    path: "sms-messages",
    component: SmsMessagesComponent,
  },
  {
    path: "whatsapp-devices",
    component: WhatsappDevices,
  },
];
